var link = 'iwoi4u0';

export { link };
//# sourceMappingURL=link-button.css.js.map
